import React from 'react';
import { useFetchResponseTimeConsolidated } from '../../hooks/useFetchResponseTimeConsolidated';
import { format } from 'date-fns';
import { api_auth } from '../../../../common/globals/constants';
import { useDynamicViewState } from '../../context/dynamic-view-context';
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import { Alert } from '@mui/material';
import { Box } from '@material-ui/core';
import { ResponseTimeConsolidated } from '../../../../components/IndividualCharts/ResponseTime/ResponseTimeConsolidated';

const URL_PARAMS = ({ objetivoId, periodo }) => {
  let fechaInicio = '';
  let fechaTermino = '';
  if (periodo.period === 'c') {
    fechaInicio = format(new Date(periodo.statePeriod.startDate), 'yyyy-MM-dd');
    fechaTermino = format(new Date(periodo.statePeriod.endDate), 'yyyy-MM-dd');
  }

  const token = sessionStorage.getItem('key');
  const user = sessionStorage.getItem('user');
  const URL = new URLSearchParams();
  URL.append('user', user);
  URL.append('key', api_auth);
  URL.append('token', token);
  URL.append('horarioId', '0');
  URL.append('objetivoId', objetivoId);
  URL.append('t', periodo.period);
  URL.append('fechaInicio', fechaInicio);
  URL.append('fechaTermino', fechaTermino);
  URL.append('nodoId', '0');
  return URL;
};

export const ResponseTimeConsolidatedChart = React.memo(({ objetivoId }) => {
  const { filterPeriod, refreshTime } = useDynamicViewState();
  const {
    data: dataResponseTimeConsolidated,
    isLoading,
    error,
    isFetching,
  } = useFetchResponseTimeConsolidated({
    urlParams: URL_PARAMS({
      objetivoId,
      periodo: filterPeriod,
    }),
    fetchApi:
      filterPeriod.period === 'c'
        ? 'getDetalleRendimientoGlobalObjetivoCustom'
        : 'getDetalleRendimientoGlobalObjetivo',
    refreshTime,
  });

  if (isLoading || isFetching) return <AtCircularProgress />;
  if (error) return <Alert severity="error">Error al cargar los datos.'</Alert>;

  return (
    <Box>
      <ResponseTimeConsolidated externalData={dataResponseTimeConsolidated} />
    </Box>
  );
});
